/**
 * CAVIAR — mega-menu gedrag zoals grote sieradenmerken:
 * op desktop opent hoveren het panel en navigeert een klik op het
 * top-item naar zijn eigen URL (bijv. Shop -> alle producten).
 * Onder 990px (drawer-menu) blijft alles standaard Dawn.
 */
(function () {
  const desktop = window.matchMedia('(min-width: 990px)');
  let hoverTimer = null;

  document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');
    if (!details || !summary) return;
    const url = summary.dataset.caviarNavUrl;

    menu.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(hoverTimer);
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (other) {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      hoverTimer = setTimeout(function () {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });

    summary.addEventListener('click', function (event) {
      if (!desktop.matches) return; // mobiel/drawer: normaal toggelen
      if (url && url !== '#') {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = url;
      }
    });
  });
})();
